import React from 'react';
import classNames from 'classnames';
import { useRoflStore } from 'store/roflStore';

interface IMoreFieldsButtonProps {
    onClick?: () => void;
}

export const MoreFieldsButton = ({ onClick }: IMoreFieldsButtonProps) => {
    const moreFieldsBtnClassnames = classNames('btn btn-default more-fields-btn');

    const hideRequiredError = useRoflStore(state => state.hideRequiredError);

    const handleClick = () => {
        if (onClick) {
            onClick();
        }
        hideRequiredError();
    };

    return (
        <button
            className={moreFieldsBtnClassnames}
            onClick={handleClick}
            type='button'
            aria-label='Add more fields'
            data-testid='more-fields-btn'
        >
            <i className='fa fa-plus-circle' />
            More Fields
        </button>
    );
};
